import { ctor } from "from2";
import { async } from "regenerator-runtime";
import { req } from "../js/config";
import axios from "axios";

//import { ToHTML, ToHTMLWithFormatting } from "../js/base";
//import { async } from "regenerator-runtime";

const Initialize = async () => {

    try {

        await loadJavascriptNow();

        const loader = document.querySelector(".loader");
        loader.className += " hidden"; // class "loader
        /*loginClick();*/
    }
    catch (err) {
        window.location = "index.html"
    }


}
const generateTPL_ErrorMessage = () => {
    var tpl = `<div class="row col-sm-12"><h2 class="text-dark">Sign In Failed!!!</h2> </div>
    <div class="row col-sm-12"><p class="lead font-weight-bold mb-4 mb-md-5">Email or Password is not Correct.</p></div>`;
    document.querySelector('#login_status').innerHTML = tpl;
}
const loginClick = async () => {


    let rp = await loginReq(document.querySelector('#login_email').value, document.querySelector('#login_password').value)
    console.log("Response from Backend - ", rp);

    if (typeof rp !== 'undefined') {
        if (rp.result.status === 200) {


        }
        else if (rp.status === 400) {
            console.log('Email or Password is not Correct', 'Sign In Failed!!!')
            generateTPL_ErrorMessage();
        }
    }
    else {
        console.log('Critical Error, Please check with administrator',)
        generateTPL_ErrorMessage();
    }


}

document.querySelector('#hansen_loginForm').addEventListener("submit", async (e) => {
    e.preventDefault();

    await loginClick();


});

const loginReq = async (email, pass) => {

    var resp = await axios.post(
        'https://api.yootechnologies.com/admin/login', {
        "email": email, "password": pass
    }).then((res) => {
        if (res.status === 200)
            console.log("🚀 ~ file: main.js ~ line 56 ~ loginReq ~ res", res)

        localStorage.setItem("token", res.data.data.token);
        localStorage.setItem("UserEmail", res.data.data.user.email)
        window.location = './carlist.html';
        return res;
    })
        .catch((error) => {
            if (error.response.status === 400) {

                console.log('Email or Password is not Correct', 'Sign In Failed!!!')
            }
            console.log(error.response);
            return error.response.status
        });
}








const loadJavascriptNow = async () => {

    const script = document.createElement('script');
    script.src = 'assets/js/main.js';

    // Append to the `head` element
    document.head.appendChild(script);
}

Initialize();

